module.exports = __webpack_public_path__ + "static/media/webpay_payment.79681560.svg";